module.exports = __webpack_public_path__ + "img/top.29ea71de.png";